var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Modal from '@rad/components/ui/modal';
import ActionButton from '@rad/components/ui/action-button';
import { cropImage, canvasToFile } from '@rad/components/inputs/aspect-ratio-cropper';
const BANNER_WIDTH = 1200;
const BANNER_HEIGHT = 400;
const BANNER_ASPECT = BANNER_WIDTH / BANNER_HEIGHT;
const clamp = (n) => Math.min(100, Math.max(0, n));
const HeaderImagePositioner = (props) => {
    const [offset, setOffset] = React.useState(50);
    const [image, setImage] = React.useState(null);
    const frameRef = React.useRef(null);
    const dragRef = React.useRef(null);
    React.useEffect(() => {
        setOffset(50);
        setImage(null);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => setImage(img);
        img.src = props.imageUrl;
    }, [props.imageUrl, props.isOpen]);
    const handlePointerDown = (e) => {
        dragRef.current = { startY: e.clientY, startOffset: offset };
        e.currentTarget.setPointerCapture(e.pointerId);
    };
    const handlePointerMove = (e) => {
        var _a, _b;
        const drag = dragRef.current;
        const height = (_b = (_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 1;
        setOffset(prev => drag === null ? prev : clamp(drag.startOffset - ((e.clientY - drag.startY) / height) * 100));
    };
    const handlePointerUp = (e) => {
        dragRef.current = null;
        e.currentTarget.releasePointerCapture(e.pointerId);
    };
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        if (image !== null) {
            const cropHeight = Math.min(image.naturalHeight, image.naturalWidth / BANNER_ASPECT);
            const cropWidth = cropHeight * BANNER_ASPECT;
            const x = (image.naturalWidth - cropWidth) / 2;
            const y = (offset / 100) * (image.naturalHeight - cropHeight);
            const canvas = yield cropImage(image, { x, y, width: cropWidth, height: cropHeight, scale: 1 }, BANNER_WIDTH, BANNER_HEIGHT);
            const file = yield canvasToFile(canvas, 'header.jpg', 'image/jpeg');
            yield props.onSave(file);
        }
    });
    const footer = (_jsxs(_Fragment, { children: [props.hasHeader && (_jsxs(ActionButton, { className: "btn btn-outline-secondary me-auto", onClick: () => __awaiter(void 0, void 0, void 0, function* () { yield props.onReset(); }), children: [_jsx("i", { className: "bi bi-arrow-counterclockwise me-1" }), "Reset to original"] })), _jsx(ActionButton, { className: "btn btn-primary", disabled: image === null, onClick: handleSave, children: "Save Position" })] }));
    return (_jsxs(Modal, { isOpen: props.isOpen, title: "Adjust Header Position", size: "lg", onClose: props.onClose, footer: footer, children: [_jsx("p", { className: "text-muted small mb-3", children: "Drag the image up or down to choose which part shows in the header." }), _jsx("div", { ref: frameRef, onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, onPointerUp: handlePointerUp, className: "position-relative overflow-hidden rounded", style: { width: '100%', aspectRatio: `${BANNER_ASPECT}`, cursor: 'grab', touchAction: 'none', userSelect: 'none', backgroundColor: '#e9ecef' }, children: _jsx("img", { src: props.imageUrl, alt: "", draggable: false, style: { width: '100%', height: '100%', objectFit: 'cover', objectPosition: `center ${offset}%`, pointerEvents: 'none' } }) })] }));
};
export default HeaderImagePositioner;
